var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoomElectricityFan({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-svg-class": "RoomButton-fill",
    width: 39,
    height: 39,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    "data-svg-class": "RoomButton-stroke",
    width: 38,
    height: 38,
    x: 0.5,
    y: 0.5,
    rx: 4
  }), /*#__PURE__*/React.createElement("circle", {
    "data-svg-class": "RoomButton-fill",
    cx: 20,
    cy: 20,
    r: 17
  }), /*#__PURE__*/React.createElement("circle", {
    "data-svg-class": "RoomButton-stroke",
    cx: 20,
    cy: 20,
    r: 16.5
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M24.106 19.078c2.111-.833 3.531-2.113 5.336-3.629 2.69-2.259 6.65.594 5.276 6.263-1.253 5.168-4.307 6.484-6.867 5.967-1.553-.313-3.907-2.252-5.655-4.227a4.178 4.178 0 01-2.15.591c-.47 0-.92-.077-1.341-.218-.378 2.307.049 4.2.49 6.566.639 3.427-3.848 5.382-8.138 1.374-3.912-3.654-3.543-6.92-1.809-8.847 1.067-1.187 4.016-2.24 6.649-2.78a4.057 4.057 0 011.266-3.14c-1.823-1.45-3.688-2.028-5.968-2.828C7.865 13 8.392 8.193 14.057 6.532c5.165-1.513 7.85.436 8.675 2.88.496 1.467-.013 4.395-.855 6.857a4.113 4.113 0 012.23 2.81z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M24.29 19.544l-.546.215-.126-.574a3.613 3.613 0 00-1.96-2.466l-.398-.193.144-.418c.894-2.614 1.27-5.308.855-6.536-.894-2.644-3.701-3.837-8.061-2.56-4.84 1.419-5.974 5.585-2.838 6.686.056.02 1.058.369 1.34.469 2.189.777 3.454 1.39 4.774 2.44l.45.358-.417.396a3.556 3.556 0 00-1.11 2.754l.02.427-.42.086c-2.855.586-5.49 1.638-6.377 2.624-1.874 2.084-1.52 5.068 1.778 8.148 3.666 3.424 7.906 2.306 7.306-.917-.497-2.663-.493-2.643-.58-3.564a12.091 12.091 0 01.087-3.175l.095-.58.558.187c.377.127.775.192 1.182.192.678 0 1.328-.181 1.894-.52l.356-.213.275.31c1.857 2.1 4.074 3.806 5.38 4.07 2.775.56 5.225-1.24 6.281-5.596 1.173-4.836-1.927-7.896-4.468-5.762-.12.101-.76.641-.94.79-.352.296-.636.529-.91.746-1.274 1.008-2.348 1.672-3.624 2.176z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    "data-svg-class": "RoomButton-fill",
    cx: 20,
    cy: 20,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    "data-svg-class": "RoomButton-stroke",
    cx: 20,
    cy: 20,
    r: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomElectricityFan);
export default __webpack_public_path__ + "static/media/RoomElectricityFan.89703edc4aefcf39e49895c19d884b6b.svg";
export { ForwardRef as ReactComponent };